import * as React from 'react';
import { Alert } from 'reactstrap';
import Icon from './Icons';

type Props = {
  children: React.ReactNode;
  type: 'warning' | 'success';
  title?: string;
  message?: string;
};

export const Colors = {
  warning: {
    bg: '#FDEFED',
    icon: '#A53F31',
  },
  success: {
    bg: '#ECF7FF',
    icon: '#23618E',
  },
};

const Message: React.FunctionComponent<Props> = ({
  children,
  title,
  message,
  type,
}) => {
  const RenderIcon = () => {
    switch (type) {
      case 'warning':
        return (
          <Icon.ExclamationCircle
            fill={Colors[type].icon}
            size={18}
            style={{ marginRight: 10 }}
          />
        );
      case 'success':
        return (
          <Icon.Info
            fill={Colors[type].icon}
            size={18}
            style={{ marginRight: 10 }}
          />
        );
    }
  };

  return (
    <Alert
      className="message"
      style={{ background: Colors[type].bg, marginTop: 25 }}
    >
      {RenderIcon()}
      <div className="contents">
        {!!title && <p className="title">{title}</p>}
        {!!message && <span className="message">{message}</span>}
        {children}
      </div>
    </Alert>
  );
};

export default Message;
